import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { setCursorByID } from 'cd-eft/utils/setHtmlElementProperty';

const setStore = stores.AppStore.surveyEngineeringStore;

export class PointTranslationSelectPointButtonVM {
  @observable shouldDisplayOnMap = false;
  @observable props;
  constructor(props: any) {
    this.props = props;
    if (setStore.translationOptionApplied !== 0) this.translationOption = setStore.translationOptionApplied;
  }

  @observable translationOption: number = 1;
  @observable desirableOption: number = 0;
  @observable pointTranslationDialogIsOpen: boolean = false;

  // select Translation Option (open confirmation Popup if current translation not saved)
  onClickStartSelectPoint(e) {
    e.preventDefault();
    this.props.setFormError('');
    setStore.selectPointType = this.props.pointType;
    const pointTypes = ['pivotRef', 'pivotTarget', 'angleRef', 'angleTarget', 'transRef', 'transTarget'];
    for (const pntType of pointTypes) {
      setStore[`${pntType}InSelectMode`] = false;
    }
    const currentType = `${this.props.pointType}InSelectMode`;
    setStore[currentType] = true;
    const cursorStyle = setStore[currentType] ? 'crosshair' : 'default';
    setCursorByID('mainView', cursorStyle);
    if (
      (setStore.selectPointType.startsWith('pivot') || setStore.selectPointType.startsWith('trans')) &&
      setStore.transSketchVM
    ) {
      setStore.transSketchVM.cancel();
      setStore.rotateSketchVM?.cancel();
      setStore.transSketchVM.snappingOptions = setStore.refSnappingOptions!;
      setStore.initValuesTransformation();
      setStore.transSketchVM.create('polyline');
      setStore.transSketchVM.layer.removeAll();
    }
    if (setStore.selectPointType.startsWith('angle') && setStore.rotateSketchVM) {
      setStore.transSketchVM?.cancel();
      setStore.rotateSketchVM.cancel();
      setStore.rotateSketchVM.snappingOptions = setStore.refSnappingOptions!;
      setStore.initValuesTransformation();
      setStore.rotateSketchVM.create('polyline');
      setStore.rotateSketchVM.layer.removeAll();
    }
  }
}
